import { fromLonLat, toLonLat } from 'ol/proj';

export function parsePolygon(area, start = '((') {
  try {
    return area
      .slice(area.indexOf(start) + start.length, -start.length)
      .split(',')
      .map((coords) => {
        const coordinates = fromLonLat(
          coords
            .trim()
            .split(' ')
            .map((coord) => Number(coord)),
        );
        if (Number.isNaN(coordinates[0]) || Number.isNaN(coordinates[1])) {
          throw TypeError('Invalid coordinates');
        }
        return coordinates;
      });
  } catch {
    return null;
  }
}

export function parsePolygonWHoles(area) {
  try {
    if (!area) return null;

    // убираем SRID=xxxx; если есть
    const clean = area.startsWith('SRID=') ? area.slice(area.indexOf(';') + 1) : area;

    if (!clean.startsWith('POLYGON')) return null;

    // берём всё, что внутри POLYGON((...))
    const inside = clean.slice(clean.indexOf('((') + 2, clean.lastIndexOf('))'));

    // делим на "кольца"
    const ringsRaw = inside.split('),(');

    const rings = ringsRaw.map((ring) => {
      return ring.split(',').map((coords) => {
        const coordinates = fromLonLat(
          coords
            .trim()
            .split(' ')
            .map((coord) => Number(coord)),
        );
        if (Number.isNaN(coordinates[0]) || Number.isNaN(coordinates[1])) {
          throw TypeError('Invalid coordinates');
        }
        return coordinates;
      });
    });

    return rings;
  } catch {
    return null;
  }
}

export function extractCoordinates(lineString) {
  // Проверяем, существует ли строка
  if (!lineString || typeof lineString !== 'string') {
    return [];
  }

  // Используем регулярное выражение для извлечения координат из строки
  const coordinatesMatch = lineString.match(/(\d+\.\d+)\s(\d+\.\d+)/g);

  // Проверяем, были ли найдены координаты
  if (!coordinatesMatch) {
    return [];
  }

  // Преобразуем найденные координаты в формат массива
  return coordinatesMatch.map((coord) => coord.split(' ').map(Number));
}

export function parseLine(track) {
  const line = 'LINESTRING(';
  try {
    return track
      .slice(track.indexOf(line) + line.length, -1)
      .split(',')
      .map((coords) =>
        fromLonLat(
          coords
            .trim()
            .split(' ')
            .map((coord) => Number(coord)),
        ),
      );
  } catch {
    return [];
  }
}

export function coordsToString(coordinates) {
  if (!Array.isArray(coordinates) || coordinates.length === 0) return null;

  const rings = coordinates.map((ring) => ring.map((coord) => toLonLat(coord).join(' ')).join(', '));

  return `POLYGON(${rings.map((r) => `(${r})`).join(', ')})`;
}

export function calcCenterPolygon(polygon) {
  if (polygon.length === 0) {
    return [];
  }
  let sumX = 0;
  let sumY = 0;
  const coordsPolygon = polygon.slice(0, -1);
  coordsPolygon.forEach((coords) => {
    sumY += coords[0];
    sumX += coords[1];
  });
  const centerX = sumX / coordsPolygon.length;
  const centerY = sumY / coordsPolygon.length;
  return [centerY, centerX];
}

export function normalizePolygonCoordinates(coords) {
  if (!Array.isArray(coords) || coords.length === 0) return [];

  // Если первый элемент массива - это массив координат
  if (Array.isArray(coords[0]) && Array.isArray(coords[0][0]) && typeof coords[0][0][0] === 'number') {
    return coords;
  }

  return [coords];
}
